import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Event as NavigationEvent, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { UxAppShellService } from '@eui/core';
import { BaseDirective } from '../../base.directive';

@Component({
    selector: 'eui-dimmer',
    template: '',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./_styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiDimmerComponent {
    @Input()
    get isDimmerActive() { return this._isDimmerActive; }
    set isDimmerActive(value) { this._isDimmerActive = coerceBooleanProperty(value); }
    _isDimmerActive: (true | false) = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            'eui-dimmer',
            this._isDimmerActive ? `eui-dimmer--active` : ``,
        ].join(' ').trim();
    }
    @HostBinding('attr.data-e2e') @Input() e2eAttr: string = 'eui-dimmer';

    private _DEBUG: (true | false) = false;

    constructor( public asService: UxAppShellService, router: Router) {
        // The events stream contains all the navigation events including the NavigationStart event
        // which gives information about what initiated the navigation sequence
        router.events
            .pipe(
                filter(
                    (event: NavigationEvent) => {
                        return (event instanceof NavigationStart);
                    }
                )
            )
            .subscribe(
                (event: NavigationStart) => {
                    if (this._DEBUG) {
                        console.group('NavigationStart Event');
                        // Every navigation sequence is given a unique ID.
                        console.log('navigation id:', event.id);
                        console.log('route:', event.url);
                        // The 'navigationTrigger' will be one of:
                        // - imperative : ie. user clicked on a link
                        // - popstate : browser controlled change such as Back button which gets a new, unique ID
                        // - hashchange
                        // @See: https://angular.io/api/router/NavigationStart
                        console.log('trigger:', event.navigationTrigger);
                        // The 'restoredState' property is defined when the navigation event is triggered by a 'popstate' event
                        // It will contain the ID of the previous navigation event from which the browser is returning
                    }
                    if (event.restoredState) {
                        this.asService.setDimmerActiveState(false);
                        this._isDimmerActive = false;
                        if (this._DEBUG) {
                            console.warn('restoring navigation id:', event.restoredState.navigationId);
                        }
                    }
                    if (this._DEBUG) {
                        console.groupEnd();
                    }
                }
            )
        ;
    }
}
